const verticalLabelEnum = Object.freeze({
  VERTICAL_ALL: 'PreMadeTemplatesTab_Vertical_All',
  VERTICAL_ECOMMERCE_RETAIL: 'PreMadeTemplatesTab_Vertical_Ecommerce_Retail',
  VERTICAL_OTHER: 'PreMadeTemplatesTab_Vertical_Other',
  VERTICAL_PUBLISHING_MEDIA: 'PreMadeTemplatesTab_Vertical_Publishing_Media',
  VERTICAL_RETAIL_BANKING_INSURANCE:
    'PreMadeTemplatesTab_Vertical_Retail_Banking_Insurance',
  VERTICAL_SPORTS_BETTING_GAMING: 'PreMadeTemplatesTab_Vertical_Betting_Gaming',
  VERTICAL_TRAVEL_TRANSPORT: 'PreMadeTemplatesTab_Vertical_Travel_Transport'
})

export { verticalLabelEnum }



// WEBPACK FOOTER //
// ./src/modules/campaigns/enum/VerticalLabelEnum.js